import React from 'react';
import styled from 'styled-components';
import { loadAnim } from '../../containers/Donation/actions';
import { width } from '../../utils/size';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;

    @media (max-width: 30em) {
        padding: 1.125em 1em;
    }
`;

const AnimationParent = styled.div`
    position: absolute;
    right: -2px;
    left: -2px;
    top: -2px;
    bottom: -2px;
`;

const AnimationWrapper = styled.div`
    width: 100%;
    height: 100%;

    @media (max-width: 30em) {
        width: 480px;
        margin-left: -${(480 - width()) / 2}px;
    }
`;

class DonationSubmitting extends React.Component {
    componentDidMount = () => {
        this.setContainer(this.animationWrapper);
    };

    setContainer = element => {
        if (element) loadAnim(element);
        return;
    };

    render() {
        return (
            <Container>
                <AnimationParent>
                    <AnimationWrapper innerRef={i => (this.animationWrapper = i)} />
                </AnimationParent>
            </Container>
        );
    }
}

export default DonationSubmitting;
